// extracted by mini-css-extract-plugin
export default {"wrapper":"Partner_wrapper__MAgyE","partners":"Partner_partners__Qg6zb","swiper-slide":"Partner_swiper-slide__qpqK8","partner":"Partner_partner__CmzxM"};